/**
* =========================================================================================
* Component - Add New button
* =========================================================================================
* 
**/

import React from 'react';
import * as Icon from 'ubs-icons';
import { COLOR } from '../../constant';

const AddNewButton = ({action, title, hideAddNew = false , disabled = false, className = ''}) => {

    return (
        <React.Fragment>
            
            <button className={`u_btn__dashed ${disabled ? 'u_disable' : ''} ${className || ''}`} type="button" onClick={disabled ? ()=> {} : action}>
                <Icon.Plus fill={COLOR.u_blue} size={14} className="u_mr-10" />
                {hideAddNew ? '' : 'Add New'} {title || ''}
            </button>
            
        </React.Fragment>
    )
}

export default AddNewButton;
